import { API } from './index'
import {
  engineServiceUrl,
  identityServiceUrl,
  labravAWSEngineServiceUrl,
} from '../utils/constants'

export const getPartnerDataFromEngineService = (
  partnerId: string,
  fetchOktaUser: boolean
) =>
  API.get(`${engineServiceUrl}/partners/${partnerId}`, {
    params: {
      fetch_okta_users: fetchOktaUser,
    },
  })

export const patchPartnerEngineService = (partnerId: string, data: object) =>
  API.patch(`${labravAWSEngineServiceUrl}/partners/${partnerId}`, data)

export const patchPartnerIdentityService = (partnerId: string, data: object) =>
  API.patch(`${identityServiceUrl}/partners/${partnerId}`, data)

export const patchPartnerAWSDetails = (
  partnerId: string,
  data: {
    iam_policies: {
      environment: string
      policy: object
    }[]
  }
) => API.patch(`${engineServiceUrl}/partners/${partnerId}/aws-details`, data)

export const getCheckS3Connection = (
  partnerId: string,
  env: 'production' | 'staging'
) =>
  API.get(`${engineServiceUrl}/partners/${partnerId}/check-s3connection`, {
    params: {
      environment: env,
    },
  })

export const fetchLastSyncHistory = (partnerId: string) =>
  API.get(`${labravAWSEngineServiceUrl}/partners/${partnerId}/referrals`, {
    params: {
      object_type: 'opportunity',
      page_size: 1,
      page_number: 1,
      sort_order: 'desc',
      sort_by: 'updated_at',
      referred_by: 'partner',
    },
  })
